"use strict";

var _classCallCheck = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\staff-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\staff-app\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\staff-app\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _inherits = require("C:\\Projects\\Business\\Ordaap\\ordaap-chat-codebase\\ordaap-backend\\components\\staff-app\\node_modules\\@babel\\runtime/helpers/inherits");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var notification_1 = require("../../messages/notification");

var base_1 = __importDefault(require("../base"));

var methods_factory_1 = require("../methods-factory");

var NotifierClient =
/*#__PURE__*/
function (_base_1$default) {
  _inherits(NotifierClient, _base_1$default);

  function NotifierClient(options) {
    var _this;

    _classCallCheck(this, NotifierClient);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(NotifierClient).call(this, options));
    _this.acceptInternalNotification = methods_factory_1.AcceptMessageFactory(notification_1.InternalNotification, 1);
    _this.sendDepartmentNotification = methods_factory_1.SendMessageFactory();
    _this.sendGuestNotification = methods_factory_1.SendMessageFactory();
    _this.sendPropertyNotification = methods_factory_1.SendMessageFactory();
    _this.sendStaffNotification = methods_factory_1.SendMessageFactory();
    return _this;
  }

  return NotifierClient;
}(base_1.default);

exports.NotifierClient = NotifierClient;
exports.default = NotifierClient;